export default __webpack_public_path__ + "static/JayJohnson-b24853a2fc88c20369afd8dcd7022e1e.jpg";